import { render, staticRenderFns } from "./lighthouseSCList.vue?vue&type=template&id=53c6b06f&"
import script from "./lighthouseSCList.vue?vue&type=script&lang=js&"
export * from "./lighthouseSCList.vue?vue&type=script&lang=js&"
import style0 from "./lighthouseSCList.vue?vue&type=style&index=0&id=53c6b06f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports